export default __webpack_public_path__ + "static/media/sp_delete.ad21782a.svg";